export const LIBRARY = `
	query library($id: Uint) {
		library(id: $id) {
			id
			name
			hidden
			description
			sort_order
			parent_library_id
			media {
				nodes {
					id
					name
					src
					type
					hidden
					size
					mime_type
					created_at
					updated_at
				}
			}
			libraries {
				id
				name
				hidden
				parent_library_id
				updated_at
			}
			groups {
				id
				name
			}
		}
	}
`;

export const ATTENDEE_MATERIALS_LIBRARY = `
	query attendeeMaterialsLibrary($event_id: Uint){
		attendeeMaterialsLibrary(event_id: $event_id){
			id
			name
			description
			sort_order
			media {
				nodes{
					id
					name
					src
					type
					hidden
					size
					mime_type
					created_at
					updated_at
				}
			}

			libraries {
				id
				name
				hidden
				parent_library_id
				updated_at
			}
		}
	}

`;

export const LIBRARY_MEDIA_CONTENT = `
	query libraryMediaContent($library_id: Uint, $search_term: String){
		libraryMediaContent(library_id: $library_id, search_term: $search_term){
			media {
				nodes{
					id
					name
					src
					type
					hidden
					size
					mime_type
					created_at
					updated_at
				}
			}

			libraries {
				id
				name
				hidden
				parent_library_id
				updated_at
			}
		}
	}

`;
